function ConversationItem({
  userName,
  location,
  message,
  time,
  isUnread = false,
  onClick,
}) {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      className={`conversation-item ${
        isUnread ? 'conversation-item--is-unread' : ''
      }`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <div className="conversation-item__content">
        <div className="conversation-item__avatar">
          <div className="conversation-item__avatar-img"></div>
        </div>
        <div className="conversation-item__info">
          <div className="conversation-item__user">
            <span className="conversation-item__user-name">{userName}</span>
            <span className="conversation-item__location">{location}</span>
            <span className="conversation-item__message">{message}</span>
          </div>
        </div>
      </div>
      <span className="conversation-item__time">{time}</span>
    </div>
  );
}

export default ConversationItem;
